import React, { useRef, useState } from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import PageBanner from "./../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";
import NewsData from "../data/news.json";
import { Link } from "react-router-dom";
import NewsGrid from "../components/news";

const NewsPage = () => {
    const contRef = useRef(null);
    const [visibleCount, setVisibleCount] = useState(60);

    const handleViewMore = () => {
        setVisibleCount((prevCount) => prevCount + 3);
    };

    const handleScrollToHeader = () => {
        if (contRef.current) {
            const headerPosition = contRef.current.offsetTop;
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };

    return (
        <React.Fragment>
            <Layout>
                <SEO title="News | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header onPressSkipButton={handleScrollToHeader} />
                    <PageBanner
                        title="News"
                        excerpt=""
                        image="/images/banner/page/news.png"
                    />

                    <div className="container">
                        <div className="section-title text-center"></div>
                        <br />

                        <ul className="row mb-n8 justify-content-center mt-2">
                            {NewsData.slice(0, visibleCount).map((news) => (
                                <div
                                    key={news.id}
                                    className="mb-7 col-md-4 col-sm-6 d-flex"
                                >
                                    <NewsGrid data={news} />
                                </div>
                            ))}
                        </ul>

                        {visibleCount < NewsData.length && (
                            <div className="text-center mt-8">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleViewMore}
                                    aria-label="View more news"
                                >
                                    View More
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <br />
                <Footer />
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default NewsPage;
